module.exports = __webpack_public_path__ + "7ae2b713c8b3be5cb8e663cedf30c469.svg";